import { IRGPUpdate } from "../../Models/Inventory";
import { TStore } from "../../hooks/useService";
import { TRANSACTION_STATUS } from "../../utils/constant";
import { POST, respond } from "../Helpers";
import { IGetBusinessUnitsData, IGetBusinessService, IGetInventoryData, TGetInventoryService, IStocktranferData, TGetcommerceSkuService, TGetcommerceSkuData, TGetStoReqService, TGetStoReqData, TCreateStoReqService, TCreateStoReqData, InventoryAdjustmentParams, IStoUpdatePayload, IStoCancelPayload, TfetchStos, TAcknowledgeStockTransferOrderData, TAcknowledgeStockTransferOrderService, IStoDeliveryChallanPayload, IGetExternalLocations, IRGPDeliveryChallanPayload, IRGPCancelPayload, IRGPCustomerSearch, IIRNRegeneration } from "./types";

export const fetchInventory: TGetInventoryService = (params) => {
  return async (store: TStore) => {
    const { setInventories } = store.inventoryStore;
    const { error, data } = await POST<IGetInventoryData>(
      "/fetchInventory",
      { ...params },
      true
    );

    if (data !== null) setInventories(data!);
    return respond(data, error);
  };
};

export const fetchBusinessUnits: IGetBusinessService = (params) => {
  return async (store: TStore) => {
    const { setBusinessUnits } = store.inventoryStore;
    const { error, data } = await POST<IGetBusinessUnitsData>(
      "/fetchBusinessUnits",
      { ...params },
      true
    );

    if (data !== null) setBusinessUnits(data!);
    return respond(data, error);
  };
};

export const createStockTransferOrder = (params: IStocktranferData) => {
  return async (store: TStore) => {
    const { setTransactionInfo } = store.transactionsStore
    const { error, data } = await POST<IStocktranferData>(
      "/createStockTransferOrder",
      {...params},
      true
    )
    if( data !== null ) {
      setTransactionInfo(prev => ( { ...prev, status : TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER }))
    }
    return respond(data, error);
  }
}

export const inventoryAdjustment = (params: InventoryAdjustmentParams) => {
  return async (store: TStore) => {
    const { error, data } = await POST<InventoryAdjustmentParams>(
      "/inventoryAdjustment",
      {...params},
      true
    )
    return respond(data, error);
  }
}
export const getAllProduct: TGetcommerceSkuService = (params) => {
  return async (store: TStore) => {
    const { setProducts } = store.inventoryStore;
    const { error, data } = await POST<TGetcommerceSkuData>(
      "/getAllProduct",
      { ...params },
      true
    );

    if (data !== null) setProducts(data!);
    return respond(data, error);
  };
};    

export const createOrUpdateStockRequest: TCreateStoReqService = (params) => {
  return async (store: TStore) => {
    // const { setProducts } = store.inventoryStrore;
    const { error, data } = await POST<TCreateStoReqData>(
      "/createOrUpdateStockRequest",
      { ...params },
      true
    );

    // if (data !== null) setProducts(data!);
    return respond(data, error);
  };
};

export const getStockRequest: TGetStoReqService = (params) => {
  return async (store: TStore) => {
    const { setStockRequest } = store.inventoryStore;
    const { error, data } = await POST<TGetStoReqData>(
      "/getStockRequest",
      { ...params },
      true
    );

    if (data !== null) setStockRequest(data!);
    return respond(data, error);
  };
};

export const updateAWBNumber = (params: IStoUpdatePayload) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IStoUpdatePayload>(
      "/updateAWBNumber",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const cancelSTOTransfer = (params: IStoCancelPayload) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IStoCancelPayload>(
      "/cancelSTOTransfer",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const getStoDeliveryChallan = (params: IStoDeliveryChallanPayload) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IStoDeliveryChallanPayload>(
      "/getStoChallanInvoice",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const getStos: any = (params:any) => {
  return async (store: TStore) => {
    const { setInventoriesStoRows } = store.inventoryStore;
    let {page, pageSize} = params;
    
    const { error, data } = await POST<TfetchStos>(
      '/fetchStockTransferOrders',
      { ...params },
      true
    );

    

    if (data !== null) setInventoriesStoRows(data);
    return respond(data, error);
  };
};

export const getStosLineItem: any = (params:any) => {
  return async (store: TStore) => {
    const { setInventoriesStoLineItemsRows } = store.inventoryStore;

    const { error, data } = await POST<TfetchStos>(
      '/fetchStockTransferOrders',
      { ...params },
      true
    );

    if (data !== null) setInventoriesStoLineItemsRows(data!.data);
    return respond(data, error);
  };
};

export const acknowledgeStockTransferOrder:TAcknowledgeStockTransferOrderService = (params) => {
  return async (store: TStore) => {
    // const { setInventoriesStoRows } = store.inventoryStore;
    const { error, data } = await POST<TAcknowledgeStockTransferOrderData>(
      `/acknowledgeStockTransferOrder`,
      { ...params },
      true
    );

    // if (data !== null) setInventoriesStoRows(data!.data);
    return respond(data, error);
  };
}

export const fetchExternalLocations: IGetExternalLocations = (params) => {
  return async (store: TStore) => {
    const { setExternalLocation } = store.inventoryStore;
    const { error, data } = await POST<IGetBusinessUnitsData>(
      "/fetchExternalLocations",
      { ...params },
      true
    );

    if (data !== null) setExternalLocation(data!);
    return respond(data, error);
  };
};


export const fetchStoInventory: TGetInventoryService = (params) => {
  return async (store: TStore) => {
    const { setstoInventories } = store.inventoryStore;
    const { error, data } = await POST<IGetInventoryData>(
      "/fetchStoInventory",
      { ...params },
      true
    );

    if (data !== null) setstoInventories(data!);
    return respond(data, error);
  };
};

export const createRGPTransferOrder = (params: any) => {
  return async (store: TStore) => {
    const { error, data } = await POST<any>(
      "/createRGPTransferOrder",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const getRGPRows: any = (params:any) => {
  return async (store: TStore) => {
    const { setRGPInventoryRows } = store.inventoryStore;
    const { error, data } = await POST<TfetchStos>(
      '/fetchRGPTransferOrders',
      { ...params },
      true
    );
    
    if (data !== null) setRGPInventoryRows(data);
    return respond(data, error);
  };
};

export const getRGPLineItems: any = (params:any) => {
  return async (store: TStore) => {
    const { setRGPLineItems } = store.inventoryStore;
    const { error, data } = await POST<TfetchStos>(
      '/fetchRGPTransferOrders',
      { ...params },
      true
    );

    if (data !== null) setRGPLineItems(data!.data);
    return respond(data, error);
  };
};

export const getRGPChallanInvoice = (params: IRGPDeliveryChallanPayload) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IRGPDeliveryChallanPayload>(
      "/getRGPChallanInvoice",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const cancelRGPTransfer = (params: IRGPCancelPayload) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IRGPCancelPayload>(
      "/cancelRGPTransfer",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const acknowledgeRGPOrder = (params: IRGPUpdate) => {
  return async (store: TStore) => {
    const { error, data } = await POST<IRGPUpdate>(
      "/acknowledgeRGPOrder",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const searchRGPCustomer = (params: IRGPCustomerSearch) => {
  return async (store: TStore) => {
    const { setRGPCustomerAddress } = store.inventoryStore;
    const { error, data } = await POST<any>(
      "/searchRGPCustomer",
      {...params},
      true
    )
    if (data !== null) setRGPCustomerAddress(data);
    return respond(data, error);
  }
}

export const generateIRN = (params: IIRNRegeneration) => {
  return async (store: TStore) => {
    const { error, data } = await POST<any>(
      "/generateIRN",
      {...params},
      true
    )
    return respond(data, error);
  }
}

export const stockOutDetail = (params: any) => {
  return async (store: TStore) => {
    const { error, data } = await POST<any>(
      "/stockOutDetail",
      {...params},
      true
    )
    return respond(data, error);
  }
}